import React from "react";
import Hero1 from "../components/Hero1";
import principal from "../assets/valor360/principal.png";
import HorizontalList from "../components/horizontalList";
import Carousel2 from "../components/Carousel2";
import asesoriaFinanciera from "../assets/valor360/asesoriaFinanciera.png";
import asesoriasPortafolio from "../assets/valor360/asesoriasPortafolio.png";
import conferencias from "../assets/valor360/conferencias.png";
import HeroB from "../components/HeroB";
import heroB1 from "../assets/valor360/heroB1.png";
import heroB2 from "../assets/valor360/heroB2.png";
import esperar from "../assets/valor360/esperar.png";
import HeroC from "../components/heroC";
import Esperar from "../components/valor360/esperar";
import heroC from "../assets/valor360/heroC.png";

const Valor360 = () => {
    return (
        <>
            <Hero1
                imagen={principal}
                titulo="Valor360"
                descripcion="Creamos una estrategia a medida para que optimices al máximo tu situación financiera actual."
                botonTexto="Contacta con un asesor"
            />
            <HorizontalList
              items={[
                { label: "Beneficios", targetId: "beneficios" },
                { label: "¿En qué consiste?", targetId: "en-que-consiste" },
                { label: "¿Qué esperar del servicio?", targetId: "esperar" },
                { label: "¿Cómo aprovechar la asesoría?", targetId: "como-aprovechar" },
              ]}
            />
            <section id="beneficios" className="scroll-mt-24">
                <Carousel2
                  mostrarBoton={false}
                  items={[
                    {
                      title: "Asesoría Financiera Personal",
                      image: asesoriaFinanciera,
                      description: "Un plan a tu medida para optimizar tu situación financiera actual y avanzar con confianza hacia tus objetivos."
                    },
                    {
                      title: "Asesoría en Portafolios de Inversión",
                      image: asesoriasPortafolio,
                      description: "Servicio especializado para maximizar la rentabilidad y el crecimiento de tu patrimonio."
                    },
                    {
                      title: "Conferencias y Talleres",
                      image: conferencias,
                      description: "Capacitaciones para empresas que desean mejorar el bienestar financiero de sus colaboradores a través de educación y formación práctica."
                    }
                  ]}
                />
            </section>
            <section id="en-que-consiste" className="scroll-mt-24">
                <HeroB
                  titulo="¿En qué consiste la planificación financiera?"
                  parrafo="La planeación financiera es el proceso de establecer objetivos económicos y diseñar estrategias para administrarlos de manera eficiente. Implica analizar ingresos, gastos, inversiones y deudas para tomar decisiones informadas que permitan alcanzar metas a corto, mediano y largo plazo."
                  botonTexto="Contacta con un asesor"
                  imagen={heroB1}
                />
            </section>
            <section id="con-nosotros" className="scroll-mt-24">
                <HeroB
                  titulo="Estamos para acompañarte en cada paso y etapa"
                  parrafo="Dar el primer paso en tu planificación financiera es muy fácil. Nuestros asesores te guían en todo lo que necesitas saber sobre finanzas personales, brindándote la seguridad de estar tomando las mejores decisiones para tu presente y futuro."
                  botonTexto="Contacta con un asesor"
                  imagen={heroB2}
                  invertir={true}
                />
            </section>
            <section id="esperar" className="scroll-mt-24">
              <Esperar
                titulo="Qué esperar al hacer tu plan financiero con nosotros"
                imagen={esperar}
              />
            </section>
            <section id="como-aprovechar" className="scroll-mt-24">
              <HeroC
                titulo="Cómo sacar el mayor provecho de tu primera sesión"
                imagen={heroC}
                modo="texto"
                botonTexto="Contacta con un asesor"
                cards={[
                  {
                    title: "Prepara tu información",
                    text: "Organiza tus datos financieros para que el asesor comprenda tu situación y te oriente mejor.",
                  },
                  {
                    title: "Anota tus dudas",
                    text: "Lleva una lista de preguntas para definir un punto de partida claro.",
                  },
                  {
                    title: "Define tus metas",
                    text: "Reflexiona sobre tu futuro financiero y, si compartes finanzas, asistan juntos a la sesión.",
                  },
                ]}
              />
            </section>
            <section id="contacto" className="scroll-mt-24" />
        </>
    );
};

export default Valor360;
